// extracted by mini-css-extract-plugin
export default {"Item":"SliderItem_Item__mRc0m"};